import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useAuth } from '../../../../lib/auth'
import { userClaimIds } from '../../../../utils/userClaims'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import CoveredEntityModal from './CoveredEntityModal'

export interface UpdateCoveredEntityProps {
  className?: string
}

const UpdateCoveredEntity: React.FC<UpdateCoveredEntityProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isCoveredEntity, setIsCoveredEntity] = useState<boolean | null>(false)
  const { user } = useAuth()

  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    if (!user) {
      setIsCoveredEntity(null)
      return
    }
    const claimValue = user[userClaimIds.hipaaCoveredEntity]
    if (typeof claimValue !== 'boolean') {
      setIsCoveredEntity(null)
      return
    }
    setIsCoveredEntity(claimValue)
  }, [user])

  return (
    <section className={className}>
      <>
        <HeaderWithSecondaryButton
          headerText="HIPAA Status"
          className="section-header"
          buttonText="Change Status"
          onClick={toggleModal}
        />
        <div className="section-body">
          <p> You {isCoveredEntity ? 'are' : 'are not'} a Covered Entity under HIPAA.</p>
        </div>
      </>
      <CoveredEntityModal isOpen={isOpen} toggleModal={toggleModal} />
    </section>
  )
}

UpdateCoveredEntity.defaultProps = {
  className: '',
}

UpdateCoveredEntity.propTypes = {
  className: PropTypes.string,
}

const StyledUpdateCoveredEntity = styled(UpdateCoveredEntity)(({ theme }) => ({
  '.section-header': {
    marginBottom: '1em',
  },
  '.section-body': {
    backgroundColor: theme.colors.grayscale.white,
    borderRadius: '4px',
    padding: '24px',
    lineHeight: '1.5',
    paddingBottom: '1px',
  },
}))

export default StyledUpdateCoveredEntity
